import isEqual from 'lodash/fp/isEqual';

export const takeUntil = <TItem>(array: TItem[], searchItem: TItem) => {
  return array.slice(0, array.indexOf(searchItem) + 1);
};

export const sum = (array: number[]) => array.reduce((prev, next) => prev + next, 0);

export const groupBy = <T, K extends keyof any>(array: T[], getKey: (item: T) => K) =>
  array.reduce((previous, currentItem) => {
    const group = getKey(currentItem);
    if (!previous[group]) previous[group] = [];
    previous[group].push(currentItem);
    return previous;
  }, {} as Record<K, T[]>);

export const nonEmpty = <T>(array: (T | undefined)[]) => array.filter((x) => x) as T[];

export const areArraysEqual = <T>(array1: T[], array2: T[]): boolean => {
  return isEqual(array1, array2);
};

export const areArraysEqualIgnoringOrder = <T>(array1: T[], array2: T[], comparer?: (a: T, b: T) => number) => {
  if (array1 === array2) return true;
  if (array1.length !== array2.length) return false;

  return areArraysEqual(Array.from(array1).sort(comparer), Array.from(array2).sort(comparer));
};

/**
 * Removes an item from an array without mutating the source array
 * @param items The array
 * @param index The index to be removed
 * @returns A new array without the specified item at index, not mutating the source array
 */
export const remove = <T>(items: T[], index: number) => [...items.slice(0, index), ...items.slice(index + 1)];

export function getRandomItemInArray<T>(array: Array<T>): T {
  return array.at(Math.random() * array.length)!;
}

export const getItemInArrayForKey = <T>(array: Array<T>, key: string): T => {
  if (!key) {
    return array[0];
  }

  const nameToNumber = key
    .split('')
    .map((c) => c.charCodeAt(0))
    .reduce((a, b) => a + b, 0);

  return array[nameToNumber % array.length];
};
